import React from 'react';
import { PageType } from '../../types/api/PageType';
import { asBlock } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';
import { PageLeadPageType } from '../../_lib/components/PageLead';
import { translatePageType } from '../../_lib/components/PageType/PageTypeTitle';

export type PageTypesListProps = {
  pageType: PageType;
};

export function PageTypePageLead({ pageType }: PageTypesListProps) {
  return <PageLeadPageType pageType={pageType} title={translatePageType(pageType)} />;
}

export const PageTypePageLeadBlock = asBlock(PageTypePageLead, BlockType.pagetypepagelead);
